import { render, staticRenderFns } from "./LegendItemLoe.vue?vue&type=template&id=f19e454e&"
import script from "./LegendItemLoe.vue?vue&type=script&lang=js&"
export * from "./LegendItemLoe.vue?vue&type=script&lang=js&"
import style0 from "./LegendItemLoe.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports